import React, { useRef } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import ReactTable from 'react-table';
import cx from 'classnames';
import Table from '../Table';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './DragSortTable.scss';

const TYPE = 'row';

const DragTrComponent = ({ children, rowInfo, moveRow }) => {
  const ref = useRef(null);

  const [{ isDragging }, drag, preview] = useDrag({
    type: TYPE,
    item: () => ({ type: TYPE, id: rowInfo?.index }),
    canDrag: !rowInfo?.isDragDisabled || false,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: TYPE,
    drop: (item) => {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.id;
      const hoverIndex = rowInfo.index;
      // 드래그한 항목이 이동할 위치에 도달하지 않은 경우
      if (dragIndex === hoverIndex) {
        return;
      }
      moveRow({
        source: {
          index: dragIndex,
        },
        destination: {
          index: hoverIndex,
        },
      });
    },
  });

  drag(drop(ref));
  preview(ref);

  if (!rowInfo) {
    return <ReactTable.defaultProps.TrComponent>{children}</ReactTable.defaultProps.TrComponent>;
  }

  return (
    <div ref={ref} style={{ opacity: isDragging ? 0.5 : 1 }}>
      <ReactTable.defaultProps.TrComponent>{children}</ReactTable.defaultProps.TrComponent>
    </div>
  );
};

const DragSortTable = ({ columns, className = '', onDragEnd, list, isDragDisabled = false, ...rest }) => {
  const getTrProps = (state, rowInfo) => {
    if (rowInfo) {
      return {
        rowInfo: {
          ...rowInfo,
          isDragDisabled,
        },
      };
    }
    return {};
  };

  return (
    <DndProvider backend={HTML5Backend} context={window}>
      <Table
        TrComponent={(props) => <DragTrComponent {...props} moveRow={onDragEnd} />}
        getTrProps={getTrProps}
        data={list}
        columns={columns}
        className={cx('drag-sort-table', className)}
        {...rest}
      />
    </DndProvider>
  );
};

export default DragSortTable;
